if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');

      const prevButton = this.elements.viewer.querySelector('button[name="previous"]');
      const nextButton = this.elements.viewer.querySelector('button[name="next"]');
      if (prevButton && nextButton) {
        prevButton.addEventListener('click', (event) => {
          if (this.mql.matches) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.navigateGallery(-1);
          }
        }, { capture: true });
        nextButton.addEventListener('click', (event) => {
          if (this.mql.matches) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.navigateGallery(1);
          }
        }, { capture: true });
      }

      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    navigateGallery(direction) {
      if (this.elements.thumbnails) {
        const activeThumbnail = this.elements.thumbnails.querySelector('[aria-current="true"]');
        const activeLi = activeThumbnail ? activeThumbnail.closest('[data-target]') : null;
        if (activeLi) {
          const allThumbnailLis = Array.from(this.elements.thumbnails.querySelectorAll('[data-target]'));
          const visibleThumbnailLis = allThumbnailLis.filter(li => {
            return window.getComputedStyle(li).display !== 'none';
          });
          
          if (visibleThumbnailLis.length > 1) {
            const currentIndex = visibleThumbnailLis.indexOf(activeLi);
            if (currentIndex !== -1) {
              const targetIndex = (currentIndex + direction + visibleThumbnailLis.length) % visibleThumbnailLis.length;
              const targetLi = visibleThumbnailLis[targetIndex];
              if (targetLi) {
                this.setActiveMedia(targetLi.dataset.target, false);
                return;
              }
            }
          }
        }
      }
      
      const activeSlide = this.elements.viewer.querySelector('.product__media-item.is-active');
      const allSlides = Array.from(this.elements.viewer.querySelectorAll('.product__media-item'));
      const visibleSlides = allSlides.filter(slide => {
        return !slide.classList.contains('product__media-item--variant') || slide.parentNode.firstElementChild === slide;
      });
      
      if (visibleSlides.length <= 1) return;
      const currentIndex = visibleSlides.indexOf(activeSlide);
      if (currentIndex === -1) return;
      const targetIndex = (currentIndex + direction + visibleSlides.length) % visibleSlides.length;
      const targetSlide = visibleSlides[targetIndex];
      if (targetSlide) {
        this.setActiveMedia(targetSlide.dataset.mediaId, false);
      }
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');



      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      const container = this.elements.thumbnails.slider;
      const isVertical = this.classList.contains('media-gallery--vertical-thumbnails');

      if (isVertical) {
        const containerTop = container.scrollTop;
        const containerBottom = containerTop + container.clientHeight;
        const elemTop = thumbnail.offsetTop;
        const elemBottom = elemTop + thumbnail.clientHeight;

        if (elemTop < containerTop || elemBottom > containerBottom) {
          container.scrollTo({
            top: elemTop - (container.clientHeight / 2) + (thumbnail.clientHeight / 2),
            behavior: 'smooth'
          });
        }
      } else {
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        container.scrollTo({
          left: thumbnail.offsetLeft - (container.clientWidth / 2) + (thumbnail.clientWidth / 2),
          behavior: 'smooth'
        });
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
